import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';
import './index.scss';

/**
 * Compact dark rounded-square icon-only button used as a toggle affordance
 * in editorial section tabbars and page back-bars (Home page Edit Profile
 * toggle, BandPage Edit band toggle, etc.). When `active` is true the
 * button switches to the warm `--ed-accent` fill — same idiom across the
 * app, no per-page duplication.
 */
export default function EditorialIconButton({
  icon,
  label,
  active = false,
  onClick,
  className = '',
  type = 'button',
}) {
  return (
    <button
      type={type}
      className={classNames(
        'editorial-icon-button',
        active && 'editorial-icon-button--active',
        className,
      )}
      aria-label={label}
      aria-pressed={active}
      onClick={onClick}
    >
      {icon}
    </button>
  );
}

EditorialIconButton.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string,
};
